import { DefaultRootState } from "stores";

export const getFavoriteSounds = (state: DefaultRootState) => {
  return state.entities.userSoundMastrSettings.favoriteSounds;
};

export const getSoundsHistories = (state: DefaultRootState) => {
  return state.entities.userSoundMastrSettings.soundHistories;
};
